module.exports = __webpack_public_path__ + "img/product14.5e453d26.png";